var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.026,
    height: 72.002,
    viewBox: "0 0 72.026 72.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4034",
    "data-name": "Group 4034",
    transform: "translate(-509.987 -834.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3370",
    "data-name": "Path 3370",
    d: "M2649.558,892.286v14.663h7.6V892.286Z",
    transform: "translate(-2111 -34.519)",
    fill: "#ebd3fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "product",
    transform: "translate(509.987 834.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3556",
    "data-name": "Group 3556",
    transform: "translate(0 0.079)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3555",
    "data-name": "Group 3555",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3366",
    "data-name": "Path 3366",
    d: "M71.663,65,58.226,51.559A32.314,32.314,0,1,0,51.5,58.28L64.941,71.717a1.241,1.241,0,0,0,1.755,0l4.966-4.966A1.241,1.241,0,0,0,71.663,65ZM32.3,62.15A29.794,29.794,0,1,1,62.1,32.356,29.829,29.829,0,0,1,32.3,62.15Zm21.618-4.966,3.21-3.21L59.1,55.942l-3.21,3.21Zm11.9,11.9-8.176-8.176,3.21-3.21,8.176,8.176Z",
    transform: "translate(0 -0.079)",
    fill: "#504b5f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3558",
    "data-name": "Group 3558",
    transform: "translate(4.99 5.045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3557",
    "data-name": "Group 3557"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3367",
    "data-name": "Path 3367",
    d: "M59.469,32.079A27.311,27.311,0,1,0,86.78,59.39,27.311,27.311,0,0,0,59.469,32.079Zm0,52.139A24.828,24.828,0,1,1,84.3,59.39,24.828,24.828,0,0,1,59.469,84.218Z",
    transform: "translate(-32.158 -32.079)",
    fill: "#504b5f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3560",
    "data-name": "Group 3560",
    transform: "translate(14.921 21.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3559",
    "data-name": "Group 3559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3368",
    "data-name": "Path 3368",
    d: "M129.676,136.079H97.4a1.241,1.241,0,0,0-1.241,1.241v7.448A1.241,1.241,0,0,0,97.4,146.01h1.241v13.656a1.241,1.241,0,0,0,1.241,1.241h27.311a1.241,1.241,0,0,0,1.241-1.241V146.01h1.241a1.241,1.241,0,0,0,1.241-1.241V137.32A1.241,1.241,0,0,0,129.676,136.079Zm-18.621,2.483h4.966v4.966h-4.966Zm0,7.448h4.966v4.966h-4.966Zm-12.414-2.483v-4.966h9.931v4.966Zm27.311,14.9H101.124V146.01h7.448v6.207a1.241,1.241,0,0,0,1.241,1.241h7.448a1.241,1.241,0,0,0,1.241-1.241V146.01h7.448Zm2.483-14.9H118.5v-4.966h9.931Z",
    transform: "translate(-96.158 -136.079)",
    fill: "#504b5f"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.b2a9bf9ed64a4ddaa17211cf88b84b03.svg";
export { ForwardRef as ReactComponent };